<template>
  <div class="face-camera-uploader">
    <div class="preview-wrapper" :style="previewStyle">
      <el-image :src="value || '/img/noPhoto.jpg'" fit="cover" />
    </div>
    <div class="actions">
      <el-button size="small" type="primary" @click="openCameraDialog">
        摄像头采集
      </el-button>
      <el-button size="small" @click="openUploadDialog">
        上传图片
      </el-button>
    </div>
    <face-capture-dialog
      ref="captureDialog"
      :output-width="outputWidth"
      :output-height="outputHeight"
      :max-size-kb="maxSizeKb"
      :strict="strict"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import FaceCaptureDialog from './FaceCaptureDialog'

export default {
  name: 'FaceCameraUploader',
  components: { FaceCaptureDialog },
  props: {
    value: { type: String, default: '' },
    width: { type: Number, default: 200 },
    height: { type: Number, default: 150 },
    outputWidth: { type: Number, default: 300 },
    outputHeight: { type: Number, default: 400 },
    maxSizeKb: { type: Number, default: 200 },
    strict: { type: Boolean, default: true }
  },
  computed: {
    previewStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      }
    }
  },
  methods: {
    openCameraDialog() {
      this.$refs.captureDialog.open('select')
    },
    openUploadDialog() {
      this.$refs.captureDialog.open('upload')
    },
    handleSuccess({ url, fileId }) {
      this.$emit('input', url)
      this.$emit('change', { url, fileId })
    }
  }
}
</script>

<style lang="scss" scoped>
.face-camera-uploader {
  .preview-wrapper {
    border: 1px dashed #ccc;
    overflow: hidden;

    ::v-deep .el-image {
      width: 100%;
      height: 100%;
    }
  }

  .actions {
    margin-top: 10px;
    display: flex;
    gap: 8px;
  }
}
</style>
